import { render, staticRenderFns } from "./ReminderDialog.vue?vue&type=template&id=1f0c6014&scoped=true"
import script from "./ReminderDialog.vue?vue&type=script&lang=js"
export * from "./ReminderDialog.vue?vue&type=script&lang=js"
import style0 from "./ReminderDialog.vue?vue&type=style&index=0&id=1f0c6014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c6014",
  null
  
)

export default component.exports